import Checkpoint from "./checkpoint";
import { fromSeconds } from '@core/Util/time';
import resource from "@core/Util/resources";
import {ListElementBuilder, timeUnitLabelLookup} from "./util";

export default class DelayCheckpoint extends Checkpoint {
    constructor() {
        super('offset', 'JourneyBuilder_Checkpoint_Delay', 'JourneyBuilder_Checkpoint_Delay_Description', { iconClass: 'fas fa-clock' });
    }

    get defaultOrder() {
        return 3;
    }

    get daysOfTheWeek() {
        return [
            { value: null, label: resource('JourneyBuilder_Moment_Immediate')},
            { value: 0, label: resource('Day_Sunday')},
            { value: 1, label: resource('Day_Monday')},
            { value: 2, label: resource('Day_Tuesday')},
            { value: 3, label: resource('Day_Wednesday')},
            { value: 4, label: resource('Day_Thursday')},
            { value: 5, label: resource('Day_Friday')},
            { value: 6, label: resource('Day_Saturday')}
        ];
    }

    buildTooltip(connection) {
        const config = this.readForConnection(connection);
        const contentBuilder = new ListElementBuilder();

        if(config.dateField) {
            contentBuilder.add(
                `${resource('JourneyBuilder_FilterSettings_Offset_Column')} - ${config.dateField}`
            );
        }

        if(config.seconds) {
            contentBuilder.add(
                `${fromSeconds(config.seconds, config.unit)} ${timeUnitLabelLookup[config.unit]}`
            );
        }

        // noinspection EqualityComparisonWithCoercionJS
        contentBuilder.add(this.daysOfTheWeek.find(dow => dow.value == config.weekDay).label);

        return {
            title: 'Delay checkpoint',
            content: contentBuilder.toString()
        }
    }
}